import request from '@/utils/request'
import URL from './urlTranslator'

// 加载所有操作职责
export function loadAllOperationResponsibility() {
  return request({
    url: URL.sys.loadAllOperationResponsibility,
    method: 'get'
  })
}

// 操作职责关联角色信息
export function operationResponsibilityRelatedRoles(params) {
  return request({
    url: URL.sys.operationResponsibilityRelatedRoles,
    method: 'get',
    params
  })
}

// 保存操作职责
export function saveOperationResponsibility(data, params) {
  return request({
    url: URL.sys.saveOperationResponsibility,
    method: 'post',
    data,
    params
  })
}

// 删除操作职责
export function deleteAllOperationResponsibility(params) {
  return request({
    url: URL.sys.deleteAllOperationResponsibility,
    method: 'delete',
    params
  })
}
